export enum SuccessEnum {
  SUCCESS = "SUCCESS",
}
